import React from 'react';
import HeroMarketplace from '../../../components/hero/HeroMarketplace';
import useDocumentTitle from '../../../components/useDocumentTitle';
import CategoriesMarket from '../elements/CategoriesMarket';
import { ToastContainer } from 'react-toastify';

const Marketplace = () => {
  useDocumentTitle(' Marketplace');
  return (
    <div>
      <HeroMarketplace />
      <div className="d-flex justify-content-center">
        <CategoriesMarket />
      </div>
      {/* <ToastContainer position="bottom-right" /> */}

    </div>
  );
};

export default Marketplace;
